<!-- Main navbar -->
<div class="navbar navbar-expand-md navbar-light navbar-static">
    <!-- Header with logos -->
    <div class="navbar-header navbar-dark d-none d-md-flex align-items-md-center">
        <div class="navbar-brand navbar-brand-md">
            <a routerLink="/" class="d-inline-block">
                <img src="{{ _settings.logo }}" alt="{{ _settings.logo_description }}">
            </a>
        </div>
        <div class="navbar-brand navbar-brand-xs">
            <a routerLink="/" class="d-inline-block">
                <img src="{{ _settings.logo }}" alt="{{ _settings.logo_description }}">
            </a>
        </div>
    </div>
    <!-- /header with logos -->
    <!-- Mobile controls -->
    <div class="d-flex flex-1 d-md-none">
        <div class="navbar-brand mr-auto">
            <a routerLink="/" class="d-inline-block">
                <img src="{{ _settings.logo }}" alt="{{ _settings.logo_description }}">
            </a>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
            <i class="icon-paragraph-justify3"></i>
        </button>
    </div>
    <!-- /mobile controls -->
    <!-- Navbar content -->
    <div class="collapse navbar-collapse" id="navbar-mobile">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a href="#" class="navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
        </ul>
        <span class="ml-md-3 mr-md-auto">&nbsp;</span>
        <ul class="navbar-nav">
            <li class="nav-item dropdown dropdown-user">
                <a href="#" class="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
                    <img src="../../../assets/uploads/images/profile/default/default.jpg" class="rounded-circle mr-2" height="34" alt="">
                    <span>{{ _name }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-right">
                    <!--<a href="#" class="dropdown-item"><i class="icon-user-plus"></i> My profile</a>-->
                    <!--<div class="dropdown-divider"></div>-->
                    <!--<a href="#" class="dropdown-item"><i class="icon-cog5"></i> Account settings</a>-->
                    <a href="javascript:;" class="dropdown-item" (click)="Logout()"><i class="icon-switch2"></i> Logout</a>
                </div>
            </li>
        </ul>
    </div>
    <!-- /navbar content -->
</div>
